import { InputBasico, InputData, InputMoney } from '@/components'
import { ENTITY_NAMES } from '@/constants/EntityNames'
import { IEntityUpdate } from '@/interfaces'
import { EntityUpdate } from '@/models'
import { Update } from '@/services/UpdateService'
import { Vue, Component } from 'vue-property-decorator'
import { VBtn, VCard, VCardActions, VCardText, VCol, VDialog, VIcon, VListItem, VRow, VSheet, VSpacer, VToolbar } from 'vuetify/lib'
import { AttaServices } from '@/services'
import { PropostaService } from '@/services/PropostaService'
import axios from 'axios'
import {
	getNextMonthLastDay,
	getFirstDayTwoMonthsAgo,
	compareMaxDate,
	compareMinDate,
	parseDateFromString,
	getSignDateRule,
	getMinDtFinalizacao
} from '@/utils'
import { DateTime } from 'luxon'
import { FORNECEDORES } from '@/constants'

enum TELA {
	ROTINA = 1,
	CONCLUIDO = 2,
	ERRO = 3,
	ERRO_BANCO = 4
}

@Component({})
export class EntityUpdateModal extends Vue {
	title: string = ''
	entityRefValue: any = null
	entityType: string = ''

	entity: IEntityUpdate | null = null

	modalState = false
	isLoading = false
	tela = TELA.ROTINA

	error = ''
	fornecedorNome: string = ''

	entityMinValue: DateTime | string = getFirstDayTwoMonthsAgo().toFormat('dd/MM/yyyy')
	maxDtFinalizacao: DateTime = getNextMonthLastDay()

	get inputElement() {
		switch (this.entityType) {
			case 'date':
				return InputData
			case 'text':
				return InputBasico
			case 'money':
				return InputMoney
			default:
				return InputBasico
		}
	}

	get currentInput() {
		const Input = this.inputElement

		let formatRefValue = ''

		if (this.entityRefValue) {
			formatRefValue = JSON.parse(JSON.stringify(this.entityRefValue))
			if (this.entityType == 'date') {
				try {
					formatRefValue = parseDateFromString(formatRefValue).toFormat('dd/MM/yyyy')
				} catch (error) {}
			}
		}

		return <Input disabled value={formatRefValue} />
	}

	get input() {
		const Input = this.inputElement

		// GARANTIA QUE O MODELO VAI SER ATUALIZADO E FOI CONSTRUIDO CORRETAMENTE
		if (this.entity) {
			if (this.entity.entityField == 'DtFinalizacao') {
				return <Input vModel={this.entity.entityValue} rules={getSignDateRule()} />
			}

			return <Input vModel={this.entity.entityValue} />
		}
	}

	get user() {
		const { state } = this.$store
		return state.user?.name
	}

	public render() {
		return (
			<VDialog persistent class="fade-in" clipped fixed right temporary width="649" vModel={this.modalState}>
				<VCard>
					<VToolbar flat dense color="primary" dark>
						<VRow class="d-flex">
							<span class="font-weight-medium ml-3 my-3">{this.title || 'Atualizar Entidade'}</span>
							<VSpacer />
							<VBtn x-small color="primary" depressed fab onClick={() => this.closeModal()} class="mr-3">
								<VIcon>mdi-close</VIcon>
							</VBtn>
						</VRow>
					</VToolbar>

					{this.tela === TELA.ROTINA && this.renderRoutineForm()}
					{this.tela === TELA.CONCLUIDO && this.renderRoutineCompleted()}
					{this.tela === TELA.ERRO_BANCO && this.renderInvalidBankCodeError()}

					<VCardActions vShow={this.tela === TELA.ROTINA} class="align-center justify-center py-4">
						<VBtn loading={this.isLoading} depressed color="primary" width="194" onClick={() => this.updateEntity()}>
							Salvar
						</VBtn>
						<VBtn outlined color="primary" width="194" onClick={() => this.closeModal()}>
							Cancelar
						</VBtn>
					</VCardActions>

					<VCardActions vShow={this.tela === TELA.ERRO_BANCO} class="align-center justify-center py-4">
						<VBtn depressed color="primary" width="194" onClick={() => this.closeModal()}>
							Entendi
						</VBtn>
						<VBtn outlined color="primary" width="194" onClick={() => this.cancelarProposta()}>
							Cancelar proposta
						</VBtn>
					</VCardActions>
				</VCard>
			</VDialog>
		)
	}

	renderRoutineForm() {
		return (
			<VCardText class="py-0">
				<VCol style="display: grid; grid-template-columns: auto auto; grid-column-gap: 10px;">
					<div>
						<VListItem>
							<VIcon>mdi-account-check</VIcon>
							<span class="font-weight-bold">De:</span>
						</VListItem>
						{this.currentInput}
					</div>
					<div>
						<VListItem>
							<VIcon>mdi-account-check</VIcon>
							<span class="font-weight-bold">Para:</span>
						</VListItem>
						{this.input}
					</div>
				</VCol>
			</VCardText>
		)
	}

	renderRoutineCompleted() {
		return (
			<VCardText class="py-0">
				<VSheet width="100%" height="279" class="d-flex justify-center align-center">
					<div class="text-center">
						<VBtn depressed color="#E3F3E4" fab large>
							<VIcon large color="#0B5C11">
								{!this.error ? 'mdi-check-bold' : 'mdi-error'}
							</VIcon>
						</VBtn>

						<h2 class="mt-4">{!this.error ? 'A ação foi concluída!' : this.error}</h2>
					</div>
				</VSheet>
			</VCardText>
		)
	}

	renderInvalidBankCodeError() {
		return (
			<VCardText class="py-0">
				<VSheet width="100%" class="d-flex justify-center align-center pa-4">
					<div class="text-center">
						<h2 class="mt-4">A alteração não pode ser concluída.</h2>
						<p class="mt-3">
							O <b>novo código informado não está cadastrado</b> com o QuintoAndar nem com o parceiro {this.fornecedorNome}. 
							Entre em contato com o suporte ou gere uma nova proposta com código cadastrado.
						</p>
						<p class="mt-3">
							Você também pode cancelar esta proposta, o que será refletido no app do comprador e vendedor.
						</p>
					</div>
				</VSheet>
			</VCardText>
		)
	}

	async updateEntity() {
		if (
			this.entity &&
			this.entity.entityField == 'DtFinalizacao' &&
			(!compareMaxDate(this.entity.entityValue, this.maxDtFinalizacao.plus({ days: 1 }).toFormat('dd/MM/yyyy')) ||
				!compareMinDate(this.entity.entityValue, getMinDtFinalizacao().minus({ days: 1 }).toFormat('dd/MM/yyyy')))
		)
			return

		if (this.entity && this.entityType == 'date' && this.entity.entityValue == null) {
			this.entity.entityValue = '01/01/0001'
		}
		if (this.entity && this.entityType == 'money') {
			this.entity.entityValue = this.entity.entityValue.toString()
		}

		this.isLoading = true

		try {
			if (this.entity) {
				const response = await Update.updateEntity(this.entity)
				if (response) {
					setTimeout(() => this.closeModal(), 2000)
					this.tela = TELA.CONCLUIDO
					this.$emit('entity:updated')
					await this.addObservation()
				}
			}
		} catch (e: any) {
			this.isLoading = false
			
			if (axios.isAxiosError(e) && e.response) {
				// Handle HTTP 409 for IdItau field specifically
				if (e.response.status === 409 && this.entity?.entityField === 'IdItau') {
					const { propostaId } = this.$route.params
					const proposta = await AttaServices.getProposta(Number(propostaId))
					this.fornecedorNome = proposta.result.parceiro?.nome || proposta.result.franquia?.nome || ''
					this.tela = TELA.ERRO_BANCO
					return
				}
				this.error = e.message
			} else {
				this.error = 'Ocorreu um erro ao processar sua solicitação'
			}
		} finally {
			this.isLoading = false
		}
	}

	/**
	 * Seta as informações da entidade manipulada
	 * @param title
	 * @param entityName
	 * @param entityType
	 * @param entityField
	 * @param entityRefValue
	 */
	async open(
		title: string,
		entityId: string | number,
		entityName: ENTITY_NAMES,
		entityType: string,
		entityField: string,
		entityRefValue: any
	) {
		this.title = title
		this.entity = new EntityUpdate({ entityField, entityId: entityId.toString(), entityName: entityName.toString(), entityValue: null })
		this.entityType = entityType
		this.entityRefValue = entityRefValue

		this.modalState = true
	}

	closeModal() {
		this.$emit('closeModal')
		this.modalState = false
		this.tela = TELA.ROTINA
	}

	async addObservation() {
		const { propostaId } = this.$route.params
		let observacao = `O usuário ${this.user} alterou ${this.entity?.entityField} de ${
			this.entityRefValue !== null ? this.entityRefValue : 'vazio'
		} para ${this.entity?.entityValue}`
		await AttaServices.addPropostaObservacao(Number(propostaId), observacao)
	}

	async cancelarProposta() {
		try {
			this.isLoading = true
			const { propostaId } = this.$route.params

			await PropostaService.cancelarProposta({
				propostaId: Number(propostaId),
				motivo: 'ID da proposta no banco inválido',
				fornecedor: FORNECEDORES.ITAU
			})

			let observacao = `O usuário ${this.user} cancelou a proposta devido a código de banco inválido`
			await AttaServices.addPropostaObservacao(Number(propostaId), observacao)
			
			this.isLoading = false
			this.closeModal()
			
			this.$emit('entity:updated')
		} catch (error) {
			this.isLoading = false
			this.error = 'Erro ao cancelar proposta'
		}
	}
}

export default EntityUpdateModal
